import React from 'react';
import Table from '../../component/table/table'
import {BASE_END_POINT} from '../../urls'
import axios from 'axios'
import AddIcon from '@material-ui/icons/Add';
import Fab from '@material-ui/core/Fab';
import { MDBContainer,  MDBRow, MDBCol} from "mdbreact";
import './countries.css'
import {message} from 'antd';
import allStrings from '../../assets/strings'
import { connect } from 'react-redux';
import {NavLink, withRouter,Redirect} from 'react-router-dom'
import {ChangeLanguage} from '../../redux/actions/LanguageAction'
import PaginationButtons from '../../component/pagenation/pagenation';


class Countries extends React.Component {
  
  state={
    Countries:[],
    Countries2:[],
    loading:true,
    refresh:false,
    page:1,
    pages:1,
  }

  constructor(props){
    super(props)
    window.scrollTo(0,0)
    if(this.props.isRTL){
      allStrings.setLanguage('ar')
    }else{
      allStrings.setLanguage('en')
    }
  }

  componentDidMount(){
    if(this.props.isRTL){
      allStrings.setLanguage('ar')
    }else{
      allStrings.setLanguage('en')
    } 
    this.getCountries(1,false)

  }


  getCountries = (page,refresh) =>{
    this.setState({loading:true})
    axios.get(`${BASE_END_POINT}countries?page=${page}`,{
      headers:{
        'Authorization':`Bearer ${this.props.currentUser.token}`,
        'Accept-Language':this.props.isRTL?'ar':'en'
      }
    })
    .then(response=>{
      console.log("Countries   ",response.data)
      let data = response.data.data.map(item=>[
        item.id,
        item.countryName_en,
        item.countryName_ar,
        item.countryCode,
        item.isoCode,
        item.numbersCount,
        "action"])
      console.log("DATA   ",data)
      this.setState({
        loading:false,
        refresh:false,
        Countries:response.data.data,
        Countries2:data,
        page:response.data.page,
        pages:response.data.pageCount,
      })
    })
    .catch(error=>{
      console.log("error   ",error.response)
      console.log("error2   ",error)
      this.setState({loading:false,})
    })
  }

  delete = (id) => {
    console.log("ID   ",id)
    let l = message.loading('Wait..', 2.5)
    axios.delete(`${BASE_END_POINT}countries/${id}`,{
     headers: {
       'Content-Type': 'application/json',
       'Authorization':`Bearer ${this.props.currentUser.token}`,
       'Accept-Language':this.props.isRTL?'ar':'en'
     },
    })
    .then(response=>{
      console.log("city DELETED")
      l.then(() => message.success(allStrings.done, 2.5) )
      this.getCountries(this.state.page)
    })
    .catch(error=>{
        console.log(error.response)
        l.then(() => message.error(allStrings.error, 2.5))
    })
 }

  addNewRecordButton = () =>(
    <div style={{width:'100%'}}>
      <NavLink to="addCountry">
        <Fab
          style={{background:'linear-gradient(135deg, #1D9598, #127275)',float:'left',margin:'50px 30px',width: '160px',borderRadius: '50px'}}
          letiant="extended"
          size="medium"
          color="primary"
          aria-label="add"
        >
          <AddIcon />{allStrings.addNewRecored}
        </Fab>
      </NavLink>
    </div>
  )


  render(){
    if (this.props.currentUser.user.type === "SUB-ADMIN" && !this.props.currentUser.user.permission.pages.includes('COUNTRIES')) return <Redirect to='/Home' />
  return (
    <div className="App">
        
      <MDBContainer> 
      <MDBRow>
        <MDBCol md="12">
          <div className="screenTable">
          <Table
            title={allStrings.CountriesTable}
            icon='flag'
            data={this.state.Countries}
            data2={this.state.Countries2}
            tableColumns={["#",allStrings.arabicName,allStrings.englishName,allStrings.countryCode,allStrings.isoCode,allStrings.numbersCount,allStrings.action]}
            loading={this.state.loading}
            deleteItem={(id)=>{this.delete(id)}}
            path='/CountryInfo'
            actionIndex={4}
            />
            <PaginationButtons
              page={this.state.page}
              pages={this.state.pages}
              labels={allStrings}
              onPageChange={(newPage) => {
                this.getCountries(newPage);
                this.setState({ page: newPage });
              }}
            />
            {this.addNewRecordButton()}
            </div>
        </MDBCol>
      </MDBRow>
    </MDBContainer>
    </div> 
  )
  }
}

const mapToStateProps = state => ({
  isRTL: state.lang.isRTL,
  currentUser: state.auth.currentUser,
})

const mapDispatchToProps = {
  ChangeLanguage
}

export default  withRouter(
  connect(mapToStateProps,mapDispatchToProps)(Countries)
);

